<template>
  <div id="app"></div>
</template>

<script>
export default {
  name: "login",
  mounted() {
    localStorage.setItem("username", "");
    localStorage.setItem("userid", "");
    localStorage.setItem("pic", "");
    localStorage.setItem("partadmin", "");
    var data = {
      service: "Index.Index",
    };
    this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
      if (typeof res.data === "string") {
        return this.$message.error(`服务器响应错误：${res.data}`);
      }
      localStorage.setItem("username", res.data.data.nickname);
      localStorage.setItem("userid", res.data.data.user_id);
      localStorage.setItem("pic", res.data.data.head_pic);
      localStorage.setItem("partadmin", res.data.data.partadmin);
      var tp = {
        type: "ks",
        user_id: localStorage.getItem("userid"),
      };
      console.log(localStorage.getItem("userid"));
      if (
        localStorage.getItem("userid") == "" ||
        localStorage.getItem("userid") == "undefined" ||
        localStorage.getItem("userid") == null
      ) {
        this.$router.push({ path: "/userindex" });
      } else {
        this.$axios
          .post(
            "https://jcl.junchenlun.com/stat/public/?service=Stat.addTool",
            this.$qs.stringify(tp)
          )
          .then((res) => {
            this.$router.push({ path: "/userindex" });
          });
      }
    });
  },
};
</script>




// WEBPACK FOOTER //
// src/components/login.vue